import React from 'react'
import { Waypoint } from 'react-waypoint'
import { useAppDispatch, useAppSelector } from './app/hooks'
import { setPage, setSideBarTextColor } from './app/pageIndexSlice'

export default function VisibilitySensor({ index }) {
    const dispatch = useAppDispatch()
    const sideBarColor = useAppSelector(state => state.pageIndex.sideBarTextColor)
    const handleVisibility = () => {
    	console.log('index:'+index)
        dispatch(setPage(index))
        // changing sidebar color/ homepage white cause dark bg
        if (index === 0) dispatch(setSideBarTextColor('white'))
        else {
            if (sideBarColor === 'white') return dispatch(setSideBarTextColor('black'))
            return
        }
    }
    return (
        <Waypoint onEnter={handleVisibility} />
    )
}
